/* FRESH 32 Quiz — DOM engine. Depends on window.QuizCore. */
(function () {
  var Core = window.QuizCore;
  var ARROW = '<svg class="fq__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
  var COPY_ICON = '<svg class="fq__copy-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
  var CHECK_ICON = '<svg class="fq__copy-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
  // English defaults used when cfg.i18n.<key> is not provided. Override any of these by
  // adding an "i18n" object to the quiz JSON config (one config file per locale).
  var I18N_DEFAULTS = {
    back: '← Back',
    question_counter: 'Question {n} of {total}',
    start: 'Start',
    continue: 'Continue',
    estimated_time: 'Takes about {time} to complete',
    other_label: 'Something else',
    other_placeholder: 'Type your answer here…',
    email_invalid: 'Please enter a valid email address.',
    loading_title: 'Analyzing…',
    result_eyebrow: 'YOUR RESULT',
    result_bad_news_label: 'The hard truth',
    result_mechanism_label: 'Mechanism',
    result_good_news_label: 'The good news',
    result_cta_default: 'Get my routine',
    error_title: 'Something went wrong.',
    error_body: "We couldn't load this quiz. Please refresh the page.",
    result_title_prefix: 'Your Oral Profile:',
    email_consent_notice: 'By submitting your email, you agree to receive marketing communications from FRESH 32. You can unsubscribe at any time.',
    discount_prefix: 'Use code',
    discount_suffix: 'at checkout',
    copy_label: 'Copy',
    copied_label: 'Copied!',
    discount_email_note: "We've also sent the code to your email."
  };

  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  // Returns HTML for a content field. Prefers an HTML override (treats empty <p></p> as
  // empty); otherwise wraps plain "foo\n\nbar" text into <p> blocks with escaping.
  function htmlOrEsc(html, plain) {
    if (typeof html === 'string' && html.replace(/<[^>]*>/g, '').trim()) return html;
    if (plain == null || plain === '') return '';
    return '<p>' + String(plain).split(/\n{2,}/).map(esc).join('</p><p>') + '</p>';
  }
  function nonempty(s) { return typeof s === 'string' && s.replace(/<[^>]*>/g, '').trim().length > 0; }
  // Copy text to clipboard. Uses the async Clipboard API in secure contexts, falls back
  // to a hidden-textarea + execCommand for older browsers / non-HTTPS previews. Returns a Promise.
  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.top = '-9999px'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('execCommand copy failed'));
      } catch (e) { reject(e); }
    });
  }

  function Quiz(root) {
    this.root = root;
    this.debug = root.getAttribute('data-debug') === 'true';
    // Discount codes are off by default: the offer link carries the discount now.
    // Flip 'Show discount code' in the section to bring the copy-code block back.
    this.showDiscountCode = root.getAttribute('data-show-discount') === 'true';
    this.showBenefits = root.getAttribute('data-show-benefits') !== 'false';
    this.offer = null;
    this.webhookUrl = root.getAttribute('data-webhook-url') || '';
    this.assetBase = root.getAttribute('data-asset-base') || '';
    this.landingImage = root.getAttribute('data-landing-image') || '';
    this.host = window.SHOPIFY_QUIZ || { shop_domain: location.host, page_url: location.href };
    this.cfg = null;
    this.steps = [];
    this.index = 0;
    this.answers = {};
    this.sessionId = this._id('fq_session');
    this.anonymousId = this._id('fq_anon');
    this.utm = Core.parseUTM(location.search);
    this.stepEnteredAt = 0;
    this.result = null;
  }

  // Reads the ?fq_profile=<id> URL param. Returns the profile id only if it matches a
  // key in cfg.profiles; otherwise null. Called once from boot() to decide whether to
  // skip the funnel and render a result page directly.
  Quiz.prototype._previewProfileFromUrl = function () {
    try {
      var p = new URLSearchParams(location.search).get('fq_profile');
      if (!p || !this.cfg || !this.cfg.profiles) return null;
      return Object.prototype.hasOwnProperty.call(this.cfg.profiles, p) ? p : null;
    } catch (e) { return null; }
  };

  // Localized string lookup. Reads cfg.i18n[key] when the config has loaded, falls back
  // to the English defaults above. Supports {placeholder} substitution from `vars`.
  Quiz.prototype.t = function (key, vars) {
    var src = (this.cfg && this.cfg.i18n && this.cfg.i18n[key]) || I18N_DEFAULTS[key] || '';
    if (!vars) return src;
    return String(src).replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  };

  Quiz.prototype._id = function (key) {
    try { var v = localStorage.getItem(key); if (v) return v; v = Core.genUUID(); localStorage.setItem(key, v); return v; }
    catch (e) { return Core.genUUID(); }
  };

  Quiz.prototype.assetUrl = function (name) {
    if (!name) return '';
    if (/^https?:|^\//.test(name)) return name;
    return this.assetBase ? this.assetBase + name : name;
  };

  Quiz.prototype.track = function (name, props) {
    // Preview mode (?fq_profile=…) — never send analytics. Just log to console if debug.
    if (this.previewMode) { if (this.debug) console.log('[quiz preview]', name, props); return; }
    var base = {
      quiz_id: this.cfg.quiz_id, quiz_version: this.cfg.quiz_version,
      shop_domain: this.host.shop_domain, page_url: this.host.page_url,
      session_id: this.sessionId, anonymous_id: this.anonymousId,
      utm_source: this.utm.source, utm_medium: this.utm.medium, utm_campaign: this.utm.campaign,
      utm_content: this.utm.content, utm_term: this.utm.term
    };
    var payload = Object.assign(base, props || {});
    // GTM's dataLayer. Unconditional, for the same reason as the publish below:
    // a flag on a delivery path is just a way to switch a destination off with
    // no error anywhere. Note that nothing in THIS repo reads it - the GA4
    // pixel builds its own dataLayer inside its sandbox iframe, a different
    // window entirely. This push exists for a GTM container on the theme,
    // which is outside the partial checkout; with no container it costs one
    // array push.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    // Shopify Customer Events, and the only route off this page. The theme
    // reaches neither GA4 nor Meta directly - both run in sandboxed web-pixel
    // iframes with no access to this window. analytics.publish is the supported
    // bridge; 06-event-tracking/ holds the two pixels that subscribe.
    //
    // Unconditional on purpose. A `facebook.enabled` flag here used to call
    // window.fbq straight from the theme, and a `shopify_pixel.enabled` flag
    // gated this block. Neither survived. The fbq route only ever worked
    // because the Facebook channel's app pixel happens to run runtimeContext
    // OPEN, which is Shopify's to change; and while both routes existed, one
    // config edit was enough to double-count every quiz event in Meta. The
    // feature test below is the only gate this needs.
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, payload);
        if (this.debug) console.log('[quiz] published to Shopify pixel:', name);
      } else if (this.debug) {
        console.warn('[quiz] Shopify.analytics.publish unavailable - not a Shopify storefront?');
      }
    } catch (e) { if (this.debug) console.warn('[quiz] Shopify publish failed', e); }
    if (this.debug) console.log('[quiz]', name, payload);
  };

  Quiz.prototype.boot = function () {
    var self = this;
    this.render('<div class="fq__loading"><div class="fq__spinner"></div></div>');
    this.loadConfig().then(function (cfg) {
      self.cfg = cfg; self.steps = cfg.steps || [];
      self.mergeOverrides();
      // Preview shortcut: ?fq_profile=<id> jumps straight to that profile's result page
      // with tracking + localStorage writes suppressed. Use for QA, design reviews,
      // screenshots — without polluting GTM or the Customer Events bus.
      var preview = self._previewProfileFromUrl();
      if (preview) {
        self.previewMode = true;
        self.result = { profileId: preview, scores: {} };
        self.contact = { email: '', first_name: '', phone: '', marketing_consent: false };
        if (self.debug) console.log('[quiz] preview mode — profile:', preview, '| try other profiles:', Object.keys(self.cfg.profiles || {}).join(', '));
        self.showResult();
        return;
      }
      self.track('quiz_viewed', {});
      self.restore();
      self.go(self.index, true);
    }).catch(function (err) {
      if (self.cfg) self.track('quiz_error', { message: String(err) });
      self.render('<div class="fq__step"><h2 class="fq__title">' + esc(self.t('error_title')) + '</h2><p class="fq__body">' + esc(self.t('error_body')) + '</p></div>');
      if (self.debug) console.error('[quiz] config error', err);
    });
  };

  Quiz.prototype.loadConfig = function () {
    var r = this.root;
    var src = Core.pickConfigSource({
      configUrl: r.getAttribute('data-config-url'),
      inlineJson: r.getAttribute('data-config-inline'),
      assetUrl: r.getAttribute('data-config-asset')
    });
    if (src.kind === 'inline') { return Promise.resolve(JSON.parse(src.value)); }
    if (src.kind === 'url' || src.kind === 'asset') { return fetch(src.value).then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); }); }
    return Promise.reject(new Error('no config source'));
  };

  // Merges per-step content overrides emitted by the Liquid section as
  // <script type="application/json" data-quiz-overrides>. Empty/whitespace-only
  // richtext values are treated as "no override" so the JSON config wins by default.
  Quiz.prototype.mergeOverrides = function () {
    var node = document.querySelector('script[data-quiz-overrides]');
    if (!node) return;
    var data; try { data = JSON.parse(node.textContent || '{}'); } catch (e) { return; }
    // Key off the object, not offer.url: a picked product still supplies image
    // and price even when no URL/UTM is configured.
    if (data && data.offer) this.offer = data.offer;
    var stepsOv = data && data.steps; if (!stepsOv) return;
    var steps = this.steps;
    Object.keys(stepsOv).forEach(function (id) {
      var ov = stepsOv[id]; if (!ov) return;
      var step = steps.find(function (s) { return s.id === id; }); if (!step) return;
      Object.keys(ov).forEach(function (k) {
        var v = ov[k];
        if (typeof v === 'string' && /_html$/.test(k)) { if (nonempty(v)) step[k] = v; }
        else if (typeof v === 'string') { if (v.trim()) step[k] = v; }
        else if (v != null) { step[k] = v; }
      });
    });
  };

  Quiz.prototype.render = function (html) { this.root.innerHTML = '<div class="fq__shell">' + html + '</div>'; };

  // Each step gets its own URL hash so funnels can be built on distinct URLs
  // (Clarity, GA4 with history-event page views). replaceState, deliberately:
  // pushState would make browser Back walk quiz steps, which fights both the
  // quiz's own Back button and the saved-progress restore.
  // Never runs in preview mode - ?fq_profile= links must stay shareable as-is.
  Quiz.prototype.setHash = function (name) {
    if (this.previewMode) return;
    if (!name) return;
    // Arriving on the landing screen keeps the clean URL - a #landing that the
    // visitor never navigated to is noise in the address bar and in analytics.
    // Coming back to it later does get the hash, hence the flag rather than a
    // plain "skip the landing step" check.
    if (!this._navigated) {
      this._navigated = true;
      if (this.index === 0) return;
    }
    try {
      var url = location.pathname + location.search + '#' + name;
      if (history && history.replaceState) history.replaceState(null, '', url);
    } catch (e) { if (this.debug) console.warn('[quiz] hash update failed', e); }
  };

  Quiz.prototype.go = function (i, skipSave) {
    if (this._keyHandler) { document.removeEventListener('keydown', this._keyHandler); this._keyHandler = null; }
    this.index = Math.max(0, Math.min(i, this.steps.length - 1));
    var step = this.steps[this.index];
    this.stepEnteredAt = Date.now();
    if (!skipSave) this.save();
    this.renderStep(step);
    var sh = this.root.querySelector('.fq__shell'); if (sh) sh.classList.add('fq__fade');
    if (typeof window.scrollTo === 'function') window.scrollTo(0, 0);
    this.setHash(step.id);
    this.track('quiz_step_viewed', { step_id: step.id, step_index: this.index, step_type: step.type });
    if (this.index === 0) this.track('quiz_started', {});
    var live = this.root.querySelector('[data-fq-live]'); if (live) live.textContent = (step.title || step.type);
    // focusVisible:false suppresses the keyboard-style :focus-visible ring on programmatic
    // focus. Falls back to plain .focus() on browsers that don't support FocusOptions.
    var first = this.root.querySelector('[data-fq-focus]');
    if (first) { try { first.focus({ focusVisible: false }); } catch (e) { first.focus(); } }
  };

  // Step indicator: thin segments for question steps + larger circles for education
  // inserts (the "milestone" between question groups). Completed = purple fill, current
  // = purple (with a soft glow ring on insert circles), upcoming = light gray.
  Quiz.prototype.progressHtml = function () {
    var s = this.cfg.settings || {};
    if (!s.show_progress) return '';
    var steps = this.steps, index = this.index;
    var progSteps = [], lastIdx = -1;
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].type === 'question' || steps[i].type === 'education') {
        progSteps.push({ step: steps[i], idx: i });
        lastIdx = i;
      }
    }
    var pastEnd = index > lastIdx;
    var currentPos = -1;
    for (var j = 0; j < progSteps.length; j++) {
      if (progSteps[j].idx === index) { currentPos = j; break; }
    }
    var html = '<div class="fq__steps" aria-hidden="true">';
    progSteps.forEach(function (entry, k) {
      var cls = 'fq__step-mark' + (entry.step.type === 'education' ? ' fq__step-mark--insert' : '');
      if (pastEnd || k < currentPos) cls += ' is-done';
      else if (k === currentPos) cls += ' is-current';
      html += '<span class="' + cls + '"></span>';
    });
    html += '</div>';
    html += '<div data-fq-live aria-live="polite" style="position:absolute;left:-9999px"></div>';
    return html;
  };

  // Compact header row used on question steps: ← Back on the left, "Question N of N"
  // on the right. The count uses margin-left:auto so it stays right-aligned even
  // when the back button is omitted on q1.
  Quiz.prototype.qheadHtml = function () {
    var s = this.cfg.settings || {};
    var step = this.steps[this.index];
    var showBack = s.allow_back && this.index > 0;
    var total = Core.questionTotal(this.steps, s.progress_counts || 'questions_only');
    var done = this.steps.slice(0, this.index).filter(function (x) { return x.type === 'question'; }).length;
    var current = done + 1;
    var showCount = step && step.type === 'question' && total > 0;
    if (!showBack && !showCount) return '';
    var back = showBack ? '<button class="fq__back" data-fq-back type="button">' + esc(this.t('back')) + '</button>' : '';
    var count = showCount ? '<span class="fq__qcount">' + esc(this.t('question_counter', { n: Math.min(current, total), total: total })) + '</span>' : '';
    return '<div class="fq__qhead">' + back + count + '</div>';
  };

  Quiz.prototype.backHtml = function () {
    var s = this.cfg.settings || {};
    if (!s.allow_back || this.index === 0) return '';
    return '<button class="fq__back" data-fq-back type="button">' + esc(this.t('back')) + '</button>';
  };

  Quiz.prototype.renderStep = function (step) {
    var fn = ({
      landing: this.renderLanding, question: this.renderQuestion, education: this.renderEducation,
      email_capture: this.renderEmail
    })[step.type];
    (fn || this.renderEducation).call(this, step);
  };

  Quiz.prototype.renderLanding = function (step) {
    var imgSrc = this.landingImage || (step.image ? this.assetUrl(step.image) : '');
    var img = imgSrc ? '<img class="fq__card-img" src="' + esc(imgSrc) + '" alt="">' : '';
    var bodyHtml = htmlOrEsc(step.body_html, step.body);
    var bodyBlock = bodyHtml ? '<div class="fq__body">' + bodyHtml + '</div>' : '';
    // Footnote: prefer HTML (richtext from section). Fall back to plain footnote +
    // optional structured footnote_link from the JSON config.
    var footHtml = '';
    if (nonempty(step.footnote_html)) {
      footHtml = step.footnote_html;
    } else if (step.footnote) {
      var link = (step.footnote_link && step.footnote_link.url)
        ? ' <a href="' + esc(step.footnote_link.url) + '" target="_blank" rel="noopener">' + esc(step.footnote_link.label) + ' →</a>'
        : '';
      footHtml = '<p>' + esc(step.footnote) + link + '</p>';
    }
    var foot = footHtml ? '<hr class="fq__rule"><div class="fq__footnote">' + footHtml + '</div>' : '';
    var est = step.estimated_time || '2–3 min';
    this.render(
      '<div class="fq__step"><div class="fq__card fq__card--landing">' + img +
      (step.eyebrow ? '<p class="fq__eyebrow">' + esc(step.eyebrow) + '</p>' : '') +
      '<h1 class="fq__title">' + esc(step.title) + '</h1>' +
      (step.subtitle ? '<p class="fq__subtitle">' + esc(step.subtitle) + '</p>' : '') +
      bodyBlock +
      '<div class="fq__actions"><button class="fq__btn fq__btn--primary fq__btn--block" data-fq-next data-fq-focus type="button">' + esc(step.cta_label || this.t('start')) + ARROW + '</button>' +
      '<p class="fq__est-time">' + esc(this.t('estimated_time', { time: est })) + '</p></div>' +
      foot +
      '</div></div>'
    );
    var self = this; this.root.querySelector('[data-fq-next]').addEventListener('click', function () { self.go(self.index + 1); });
  };

  Quiz.prototype.renderEducation = function (step) {
    var img = step.image ? '<img class="fq__card-img" src="' + esc(this.assetUrl(step.image)) + '" alt="">' : '';
    var bodyHtml = htmlOrEsc(step.body_html, step.body);
    this.render(
      this.progressHtml() + '<div class="fq__step">' + this.backHtml() + '<div class="fq__card">' + img +
      (step.eyebrow ? '<p class="fq__eyebrow">' + esc(step.eyebrow) + '</p>' : '') +
      '<h2 class="fq__title">' + esc(step.title) + '</h2>' +
      '<div class="fq__body">' + bodyHtml + '</div>' +
      '<div class="fq__actions"><button class="fq__btn fq__btn--primary fq__btn--block" data-fq-next data-fq-focus type="button">' + esc(step.cta_label || this.t('continue')) + ARROW + '</button></div>' +
      '</div></div>'
    );
    this.wireBack(); var self = this; this.root.querySelector('[data-fq-next]').addEventListener('click', function () { self.go(self.index + 1); });
  };

  Quiz.prototype.renderQuestion = function (step) {
    var self = this;
    var saved = this.answers[step.id] || { answerIds: [] };
    var multi = !!step.allow_multiple;
    var keys = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
    var OTHER = '__other';
    var options = (step.answers || []).slice();
    if (step.allow_free_text) options.push({ id: OTHER, label: step.free_text_label || this.t('other_label'), _other: true });
    var answersHtml = options.map(function (a, i) {
      var on = saved.answerIds.indexOf(a.id) !== -1;
      var head = '<span class="fq__answer-key">' + (keys[i] || (i + 1)) + '</span><span class="fq__answer-label">' + esc(a.label) + '</span>';
      var focusAttr = (i === 0 ? ' data-fq-focus' : '');
      if (a._other) {
        var ta = '<textarea class="fq__freetext" data-fq-freetext placeholder="' + esc(step.free_text_placeholder || self.t('other_placeholder')) + '"' + (on ? '' : ' hidden') + '>' + esc(saved.freeText || '') + '</textarea>';
        return '<div class="fq__answer fq__answer--other" role="button" tabindex="0" aria-pressed="' + on + '" data-fq-answer="' + OTHER + '"' + focusAttr + '><div class="fq__other-head">' + head + '</div>' + ta + '</div>';
      }
      return '<button class="fq__answer" type="button" aria-pressed="' + on + '" data-fq-answer="' + esc(a.id) + '"' + focusAttr + '>' + head + '</button>';
    }).join('');
    var continueBtn = '<div class="fq__actions">' +
      '<button class="fq__btn fq__btn--primary fq__btn--block" data-fq-next type="button" disabled>' + esc(this.t('continue')) + ARROW + '</button></div>';
    this.render(
      this.progressHtml() + '<div class="fq__step">' + this.qheadHtml() +
      (step.eyebrow ? '<p class="fq__eyebrow">' + esc(step.eyebrow) + '</p>' : '') +
      '<h2 class="fq__title fq__title--question" id="fq-q-title">' + esc(step.title) + '</h2>' +
      (step.subtitle ? '<p class="fq__body">' + esc(step.subtitle) + '</p>' : '') +
      '<div class="fq__answers" role="group" aria-labelledby="fq-q-title">' + answersHtml + '</div>' + continueBtn + '</div>'
    );
    this.wireBack();

    function optionDef(id) { for (var i = 0; i < options.length; i++) { if (options[i].id === id) return options[i]; } return {}; }
    function otherSelected() { var cur = self.answers[step.id]; return !!(cur && cur.answerIds && cur.answerIds.indexOf(OTHER) !== -1); }
    function toggleFreeText() {
      var ft = self.root.querySelector('[data-fq-freetext]'); if (!ft) return;
      if (otherSelected()) { ft.hidden = false; ft.focus(); } else { ft.hidden = true; }
    }
    function setSel(id) {
      var cur = self.answers[step.id] || { answerIds: [], labels: [], freeText: '' };
      if (multi) { var k = cur.answerIds.indexOf(id); if (k === -1) cur.answerIds.push(id); else cur.answerIds.splice(k, 1); }
      else { cur.answerIds = [id]; }
      cur.labels = options.filter(function (a) { return cur.answerIds.indexOf(a.id) !== -1; }).map(function (a) { return a.label; });
      if (cur.answerIds.indexOf(OTHER) === -1) { cur.freeText = ''; var ftx = self.root.querySelector('[data-fq-freetext]'); if (ftx) ftx.value = ''; }
      self.answers[step.id] = cur;
      Array.prototype.forEach.call(self.root.querySelectorAll('[data-fq-answer]'), function (b) {
        b.setAttribute('aria-pressed', cur.answerIds.indexOf(b.getAttribute('data-fq-answer')) !== -1);
      });
      toggleFreeText();
    }
    function isValid() {
      var cur = self.answers[step.id];
      if (!cur || !cur.answerIds || !cur.answerIds.length) return false;
      if (otherSelected()) {
        var ft = self.root.querySelector('[data-fq-freetext]');
        var hasText = !!(ft && ft.value.trim());
        var hasOther = cur.answerIds.filter(function (id) { return id !== OTHER; }).length > 0;
        return hasText || hasOther;
      }
      return true;
    }
    function syncUI() {
      var btn = self.root.querySelector('[data-fq-next]');
      if (btn) btn.disabled = !isValid();
    }
    var committed = false;
    function commitAndNext() {
      if (committed) return;
      var ft = self.root.querySelector('[data-fq-freetext]'); if (ft && otherSelected()) { self.answers[step.id] = self.answers[step.id] || { answerIds: [] }; self.answers[step.id].freeText = ft.value; }
      if (step.required && !isValid()) { return; }
      committed = true;
      var cur = self.answers[step.id];
      var sel = (cur && cur.answerIds[0]) || '';
      var ansDef = optionDef(sel);
      self.track('quiz_answered', {
        step_id: step.id, step_index: self.index, question_id: step.id, answer_id: sel,
        answer_label: ansDef.label || '', score_profile: ansDef.score_profile || '',
        time_on_step_seconds: Math.round((Date.now() - self.stepEnteredAt) / 1000)
      });
      self.go(self.index + 1);
    }
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-fq-answer]'), function (btn) {
      btn.addEventListener('click', function () { setSel(btn.getAttribute('data-fq-answer')); syncUI(); });
    });
    var ftEl = this.root.querySelector('[data-fq-freetext]');
    if (ftEl) { ftEl.addEventListener('input', syncUI); ftEl.addEventListener('click', function (e) { e.stopPropagation(); }); ftEl.addEventListener('mousedown', function (e) { e.stopPropagation(); }); }
    var otherCard = this.root.querySelector('.fq__answer--other');
    if (otherCard) otherCard.addEventListener('keydown', function (e) { if (e.target === otherCard && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) { e.preventDefault(); e.stopPropagation(); otherCard.click(); } });
    var next = this.root.querySelector('[data-fq-next]'); if (next) next.addEventListener('click', commitAndNext);
    syncUI();

    this._keyHandler = function (e) {
      if (e.target && e.target.tagName === 'TEXTAREA') return;
      if (e.key === 'Enter') { var b = self.root.querySelector('[data-fq-next]'); if (b && !b.disabled) { e.preventDefault(); b.click(); } return; }
      var n = parseInt(e.key, 10);
      if (n >= 1 && n <= options.length) { var btn = self.root.querySelectorAll('[data-fq-answer]')[n - 1]; if (btn) btn.click(); }
    };
    document.addEventListener('keydown', this._keyHandler);
  };

  Quiz.prototype.renderEmail = function (step) {
    var self = this, f = step.fields || {};
    function field(key, type) {
      if (!f[key]) return '';
      return '<div class="fq__field"><label class="fq__label" for="fq-' + key + '">' + esc(f[key].label || key) + (f[key].required ? ' *' : '') + '</label>' +
        '<input class="fq__input" id="fq-' + key + '" name="' + key + '" type="' + type + '" placeholder="' + esc(f[key].placeholder || '') + '"' + (f[key].required ? ' required' : '') + (key === 'email' ? ' data-fq-focus' : '') + '></div>';
    }
    // Implicit-consent pattern: the explicit checkbox is gone; the disclosure paragraph
    // below the form makes the merchant's marketing intent clear. The submission still
    // sends marketing_consent:true so downstream tools (Klaviyo etc.) get a clean signal.
    var noticeHtml = nonempty(step.consent_notice_html) ? step.consent_notice_html : esc(this.t('email_consent_notice'));
    var notice = noticeHtml ? '<p class="fq__consent-notice">' + noticeHtml + '</p>' : '';
    var subHtml = nonempty(step.subtitle_html) ? step.subtitle_html : (step.subtitle ? esc(step.subtitle) : '');
    this.render(
      this.progressHtml() + '<div class="fq__step fq__step--email">' + this.backHtml() +
      (step.eyebrow ? '<p class="fq__eyebrow">' + esc(step.eyebrow) + '</p>' : '') +
      '<h2 class="fq__title">' + esc(step.title) + '</h2>' +
      (subHtml ? '<div class="fq__body">' + subHtml + '</div>' : '') +
      '<form data-fq-form>' + field('email', 'email') + field('first_name', 'text') + field('phone', 'tel') +
      '<div class="fq__error" data-fq-emailerr style="display:none">' + esc(this.t('email_invalid')) + '</div>' +
      '<div class="fq__actions"><button class="fq__btn fq__btn--primary fq__btn--block" type="submit">' + esc(step.cta_label || this.t('continue')) + ARROW + '</button></div>' +
      notice +
      '</form></div>'
    );
    this.wireBack();
    this.root.querySelector('[data-fq-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (self.root.querySelector('#fq-email') || {}).value || '';
      if (!Core.validateEmail(email)) { self.root.querySelector('[data-fq-emailerr]').style.display = 'block'; return; }
      self.contact = {
        email: email.trim(),
        first_name: ((self.root.querySelector('#fq-first_name') || {}).value || '').trim(),
        phone: ((self.root.querySelector('#fq-phone') || {}).value || '').trim(),
        // Implicit consent — the disclosure paragraph above the submit button covers this.
        marketing_consent: true
      };
      self.track('quiz_email_submitted', {});
      self.finish();
    });
  };

  Quiz.prototype.finish = function () {
    var self = this;
    this.result = Core.computeResult(this.answers, this.cfg.scoring, this.steps);
    var prof = (this.cfg.profiles || {})[this.result.profileId] || {};
    var scoreProps = { result_profile: this.result.profileId };
    Object.keys(this.result.scores).forEach(function (k) { scoreProps['score_' + k] = self.result.scores[k]; });
    this.track('quiz_completed', scoreProps);
    this.submit(prof);
    var ms = (this.cfg.settings && this.cfg.settings.loading_screen_ms) || 1800;
    var loadingStep = this.steps.find(function (s) { return s.type === 'loading'; }) || { title: 'Analyzing…', messages: [] };
    this.renderLoadingScreen(loadingStep);
    setTimeout(function () { self.showResult(); }, ms);
  };

  Quiz.prototype.submit = function (prof) {
    if (!this.webhookUrl) { if (this.debug) console.log('[quiz] no webhook_url; skipping submit'); return; }
    var detailed = [];
    var self = this;
    (this.steps || []).filter(function (s) { return s.type === 'question'; }).forEach(function (s) {
      var ans = self.answers[s.id]; if (!ans) return;
      var def = (s.answers || []).find(function (a) { return a.id === (ans.answerIds || [])[0]; }) || {};
      detailed.push({ step_id: s.id, question_id: s.id, answer_id: (ans.answerIds || [])[0] || '', answer_label: (ans.labels || [])[0] || '', score_profile: def.score_profile || '', score_value: typeof def.score_value === 'number' ? def.score_value : 0, free_text: ans.freeText || '' });
    });
    var payload = Core.buildSubmissionPayload({
      quizId: this.cfg.quiz_id, quizVersion: this.cfg.quiz_version,
      shopDomain: this.host.shop_domain, pageUrl: this.host.page_url,
      sessionId: this.sessionId, contact: this.contact, utm: this.utm,
      locale: this.cfg.locale || '',
      leadTag: (this.cfg.tracking || {}).lead_tag || '',
      answersDetailed: detailed, scores: this.result.scores,
      result: {
        profileId: this.result.profileId,
        profileTitle: prof.title || '',
        profileName: prof.name || '',
        recommendedProductUrl: (prof.cta && prof.cta.url) || ''
      }
    });
    // Sent as a CORS "simple request" (text/plain, no-cors) so it delivers to no-code
    // webhook catchers (Pabbly/Make/Zapier/n8n) without a blocked CORS preflight.
    // The body is still JSON — the receiver parses it. Response is opaque by design.
    fetch(this.webhookUrl, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(payload) })
      .catch(function (err) { self.track('quiz_error', { message: 'submit_failed:' + err }); if (self.debug) console.warn('[quiz] submit failed', err); });
  };

  Quiz.prototype.renderLoadingScreen = function (step) {
    if (this._msgTimer) clearInterval(this._msgTimer);
    this.render('<div class="fq__loading"><div class="fq__spinner"></div><h2 class="fq__title" style="font-size:24px">' + esc(step.title || this.t('loading_title')) + '</h2><p class="fq__body" data-fq-msg>' + esc((step.messages || [])[0] || '') + '</p></div>');
    var msgs = step.messages || [], i = 0, msgEl = this.root.querySelector('[data-fq-msg]');
    if (msgs.length > 1 && msgEl) { this._msgTimer = setInterval(function () { i = (i + 1) % msgs.length; msgEl.textContent = msgs[i]; }, 700); }
  };

  Quiz.prototype.showResult = function () {
    if (this._msgTimer) clearInterval(this._msgTimer);
    var prof = (this.cfg.profiles || {})[this.result.profileId] || {};
    var img = prof.image ? '<img class="fq__result-img" src="' + esc(this.assetUrl(prof.image)) + '" alt="' + esc(prof.title || '') + '">' : '';
    var cta = prof.cta || {};
    // The bad-news / mechanism / good-news headings were removed - the copy reads
    // as one argument now. `.fq__result-label` itself stays: the *_html config
    // fields still use it for subheadings inside flowing body copy.
    function block(html, plain) {
      var body = htmlOrEsc(html, plain);
      if (!body) return '';
      return '<div class="fq__result-block"><div class="fq__body">' + body + '</div></div>';
    }
    // Product-offer banner: image left, content right (stacks on mobile). Each piece
    // (image / headline / description / benefits / discount pill / CTA) is optional;
    // missing fields are simply omitted. `description` falls back to legacy `subtext`.
    var offerImg = this.offerImage(cta);
    var offerMedia = offerImg ? '<div class="fq__offer-media"><img class="fq__offer-img" src="' + esc(offerImg) + '" alt="' + esc(this.offerImageAlt(cta, prof.title)) + '"></div>' : '';
    // Product identity comes from the section's picker; profiles only supply copy.
    var headline = cta.headline || (this.offer && this.offer.title) || '';
    var offerHeadline = headline ? '<h3 class="fq__offer-headline">' + esc(headline) + '</h3>' : '';
    var offerDesc = cta.description ? '<p class="fq__offer-desc">' + esc(cta.description) + '</p>' : '';
    var offerBenefits = '';
    if (this.showBenefits && Array.isArray(cta.benefits) && cta.benefits.length) {
      offerBenefits = '<ul class="fq__offer-benefits">' + cta.benefits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul>';
    }
    var offerUrl = this.offerUrl(cta);
    var offerPrice = this.priceRow()
      ? this.priceRow() + '<p class="fq__offer-note">' + esc(this.t('discount_auto_note')) + '</p>'
      : '';
    var offerDiscount = '';
    if (cta.discount_code && this.showDiscountCode) {
      // Discount is a prominent purple copy-to-clipboard button: code on the left, a
      // stacked copy icon + "copy" label on the right. Below it, a note that the code
      // was also emailed. The lead-in label reuses i18n discount_prefix + discount_suffix.
      var leadIn = [this.t('discount_prefix'), this.t('discount_suffix')].filter(function (s) { return s; }).join(' ');
      offerDiscount = '<div class="fq__offer-discount">' +
        (leadIn ? '<p class="fq__offer-discount-label">' + esc(leadIn) + '</p>' : '') +
        '<button class="fq__copy-code" type="button" data-fq-copy="' + esc(cta.discount_code) + '">' +
          '<span class="fq__copy-code-value">' + esc(cta.discount_code) + '</span>' +
          '<span class="fq__copy-code-action" data-fq-copy-action>' + COPY_ICON +
            '<span class="fq__copy-code-text">' + esc(this.t('copy_label')) + '</span>' +
          '</span>' +
        '</button>' +
        '<p class="fq__copy-note">' + esc(this.t('discount_email_note')) + '</p>' +
        '</div>';
    }
    var offerBtn = offerUrl
      ? '<a class="fq__btn fq__btn--primary fq__btn--block" data-fq-cta href="' + esc(offerUrl || '#') + '">' + esc(cta.label || this.t('result_cta_default')) + ARROW + '</a>'
      : '';
    // Banner structure: [top row (image + content)] → [discount line on its own row] →
    // [full-width CTA]. Each row is its own visual beat.
    var offer = '<div class="fq__offer">' +
      '<div class="fq__offer-top">' + offerMedia +
      '<div class="fq__offer-content">' + offerHeadline + offerDesc + offerBenefits + '</div>' +
      '</div>' + offerPrice + offerDiscount + offerBtn +
      '</div>';
    this.render(
      '<div class="fq__step fq__fade fq__step--result">' +
      '<p class="fq__eyebrow">' + esc(this.t('result_eyebrow')) + '</p>' +
      '<h1 class="fq__title">' + (prof.name
        ? esc(this.t('result_title_prefix')) + ' <span class="fq__profile-name">' + esc(prof.name) + '</span>'
        : esc(prof.title)) + '</h1>' + img +
      this.columnsBlock(prof, cta) +
      this.teaserCard(cta, offerUrl) +
      block(prof.bad_news_html, prof.bad_news) +
      block(prof.mechanism_html, prof.mechanism) +
      block(prof.good_news_html, prof.good_news) +
      offer +
      '</div>'
    );
    this.setHash('result-' + String(this.result.profileId).replace(/_/g, '-'));
    this.track('quiz_result_viewed', { result_profile: this.result.profileId });
    if (!this.previewMode) this.clearSaved();
    var self = this, ctaEl = this.root.querySelector('[data-fq-cta]');
    if (ctaEl) ctaEl.addEventListener('click', function () { self.track('quiz_cta_clicked', { result_profile: self.result.profileId, cta_url: offerUrl || '' }); });
    // Clearance is a flat 60px in CSS, by request - no measured inline style.
    var teaserEl = this.root.querySelector('[data-fq-teaser]');
    if (teaserEl) teaserEl.addEventListener('click', function () { self.track('quiz_cta_clicked', { result_profile: self.result.profileId, cta_url: teaserEl.getAttribute('href') || '', cta_position: 'teaser' }); });
    var copyBtn = this.root.querySelector('[data-fq-copy]');
    if (copyBtn) {
      var copyTimer = null;
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-fq-copy');
        var action = copyBtn.querySelector('[data-fq-copy-action]');
        copyToClipboard(code).then(function () {
          copyBtn.classList.add('is-copied');
          if (action) action.innerHTML = CHECK_ICON + '<span class="fq__copy-code-text">' + esc(self.t('copied_label')) + '</span>';
          self.track('quiz_code_copied', { result_profile: self.result.profileId, discount_code: code });
          if (copyTimer) clearTimeout(copyTimer);
          copyTimer = setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            if (action) action.innerHTML = COPY_ICON + '<span class="fq__copy-code-text">' + esc(self.t('copy_label')) + '</span>';
          }, 2000);
        }).catch(function (err) { if (self.debug) console.warn('[quiz] copy failed', err); });
      });
    }
  };

  // Offer image: the profile's own cta.image wins, otherwise the product
  // picker's featured image. Same precedence as offerUrl.
  Quiz.prototype.offerImage = function (cta) {
    return cta.image || (this.offer && this.offer.image) || '';
  };
  Quiz.prototype.offerImageAlt = function (cta, fallback) {
    return cta.image_alt || (this.offer && this.offer.image_alt) || fallback || '';
  };

  // Matches the checkmark used on the product pages (d-featured-products).
  var CHECK_CIRCLE = '<svg width="12" height="12" viewBox="0 0 16 16" class="fq__check" aria-hidden="true">' +
    '<circle cx="8" cy="8" r="8" fill="#A000FF"></circle>' +
    '<path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>' +
    '</svg>';

  // Optional per-profile two-column summary: symptoms + causes on the left, the
  // recommended routine as compact cards on the right. Profiles without a
  // `columns` block render exactly as before. Mobile stacks left above right.
  Quiz.prototype.columnsBlock = function (prof, cta) {
    var c = prof.columns;
    if (!c) return '';
    var list = function (items) {
      if (!Array.isArray(items) || !items.length) return '';
      return '<ul class="fq__col-list">' + items.map(function (i) {
        return '<li>' + esc(i) + '</li>';
      }).join('') + '</ul>';
    };
    var left = c.left || {}, right = c.right || {};
    // The routine column can carry its own uploaded image; the teaser and
    // offer cards deliberately stay on the product image.
    var img = (this.offer && this.offer.column_image) || this.offerImage(cta);
    return '<div class="fq__cols">' +
      '<div class="fq__col fq__col--left">' +
        (left.heading ? '<h3 class="fq__col-heading">' + esc(left.heading) + '</h3>' : '') +
        list(left.items) +
        (left.sub_heading ? '<h4 class="fq__col-subheading">' + esc(left.sub_heading) + '</h4>' : '') +
        list(left.sub_items) +
      '</div>' +
      '<div class="fq__col fq__col--right">' +
        // Image first, heading under it - the product leads, the label explains it.
        (img ? '<img class="fq__col-img" src="' + esc(img) + '" alt="" aria-hidden="true">' : '') +
        (right.heading ? '<h3 class="fq__col-heading">' + esc(right.heading) + '</h3>' : '') +
        ((right.cards || []).length
          ? '<ul class="fq__col-routine">' + right.cards.map(function (card) {
              return '<li class="fq__col-routine-item">' + CHECK_CIRCLE +
                '<span class="fq__col-routine-copy">' +
                  (card.title ? '<span class="fq__col-routine-title">' + esc(card.title) + '</span>' : '') +
                  (card.note ? '<span class="fq__col-routine-note">' + esc(card.note) + '</span>' : '') +
                '</span></li>';
            }).join('') + '</ul>'
          : '') +
      '</div>' +
      '</div>';
  };

  // Price row shared by the teaser and the full offer card. Mirrors the PDP's
  // quantity-break row: struck compare-at, current, SAVE pill.
  Quiz.prototype.priceRow = function () {
    var o = this.offer;
    if (!o || !o.price) return '';
    return '<div class="fq__offer-price">' +
      (o.compare_at ? '<span class="fq__offer-price-was">' + esc(o.compare_at) + '</span>' : '') +
      '<span class="fq__offer-price-now">' + esc(o.price) + '</span>' +
      (o.discount_pct ? '<span class="fq__offer-price-badge">' + esc(this.t('save_label')) + ' ' + esc(o.discount_pct) + '%</span>' : '') +
      '</div>';
  };

  // The section's product picker supplies url/price via data-quiz-overrides.
  // A profile's own cta.url still wins verbatim (escape hatch, UTM assumed baked
  // in). Otherwise: product URL + fixed source/medium + the profile's campaign.
  Quiz.prototype.offerUrl = function (cta) {
    if (cta.url) return cta.url;
    var base = this.offer && this.offer.url;
    if (!base) return '';
    var utm = (this.offer.utm || '') + (cta.utm_campaign ? '&utm_campaign=' + encodeURIComponent(cta.utm_campaign) : '');
    if (!utm) return base;
    return base + (base.indexOf('?') === -1 ? '?' : '&') + utm.replace(/^&/, '');
  };

  // Compact restatement of the offer, directly under the headline. Renders only
  // when the profile supplies teaser copy - no teaser, no card.
  Quiz.prototype.teaserCard = function (cta, url) {
    if (!cta.teaser_headline) return '';
    return '<a class="fq__teaser" data-fq-teaser href="' + esc(url || '#') + '">' +
      (this.offerImage(cta) ? '<img class="fq__teaser-img" src="' + esc(this.offerImage(cta)) + '" alt="" aria-hidden="true">' : '') +
      '<span class="fq__teaser-copy">' +
        (cta.teaser_headline ? '<span class="fq__teaser-headline">' + esc(cta.teaser_headline) + '</span>' : '') +
        '<span class="fq__teaser-sub">' + esc(cta.teaser_sub || this.t('teaser_sub_default')) + '</span>' +
        this.priceRow() +
      '</span>' + ARROW +
      '</a>';
  };

  Quiz.prototype.wireBack = function () {
    var self = this, b = this.root.querySelector('[data-fq-back]');
    if (b) b.addEventListener('click', function () { if (self._keyHandler) { document.removeEventListener('keydown', self._keyHandler); self._keyHandler = null; } self.track('quiz_back_clicked', {}); self.go(self.index - 1); });
  };

  // persistence
  Quiz.prototype.save = function () {
    if (!(this.cfg.settings && this.cfg.settings.save_partial_progress)) return;
    try { localStorage.setItem('fq_state_' + this.cfg.quiz_id, JSON.stringify({ v: this.cfg.quiz_version, index: this.index, answers: this.answers })); this.track('quiz_progress_saved', {}); } catch (e) {}
  };
  Quiz.prototype.restore = function () {
    if (!(this.cfg.settings && this.cfg.settings.save_partial_progress)) return;
    try { var s = JSON.parse(localStorage.getItem('fq_state_' + this.cfg.quiz_id) || 'null'); if (s && s.v === this.cfg.quiz_version && typeof s.index === 'number') { this.index = s.index; this.answers = s.answers || {}; } } catch (e) {}
  };
  Quiz.prototype.clearSaved = function () { try { localStorage.removeItem('fq_state_' + this.cfg.quiz_id); } catch (e) {} };

  function mount(root) { root.classList.add('fq'); var q = new Quiz(root); root.__fq = q; q.boot(); return q; }
  window.FreshQuiz = { mount: mount, Quiz: Quiz };
  function autoMount() { Array.prototype.forEach.call(document.querySelectorAll('[data-fresh-quiz]'), function (r) { if (!r.__fq) mount(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoMount); else autoMount();
})();
